import * as React from 'react';
import { Device } from '../common/Device';
import { HiddenBaseDesktop } from './HiddenBase.desktop';
import { HiddenBaseMobile } from './HiddenBase.mobile';

export const HiddenBaseContainer = () => {
  return <Device mobile={<HiddenBaseMobile />} desktop={<HiddenBaseDesktop />} />;
};
